export enum DialogMode {
  'ADD' = 'ADD',
  'EDIT' = 'EDIT',
}

